import { Soil } from './constants'

function getSoilHeight (cx) {
  return cx.canvas.height * Soil.HEIGHT
}

function getTopSoilHeight (cx) {
  return (cx.canvas.height * Soil.HEIGHT) - Soil.MARGIN
}

function getSoilY (cx) {
  return cx.canvas.height * (1 - Soil.HEIGHT)
}

export default {
  getSoilHeight,
  getTopSoilHeight,
  getSoilY
}
